import { useEffect, useState } from "react";
import MainNav from "./MainNav";
import TopBar from "./TopBar";
import MenuSearch from "./MenuSearch";
import getImageFromStrapi from "../../../utils/api/getImageFromStrapi";

function transformMenuData(menuInfo,translations) {
  if (!menuInfo?.data?.attributes?.menu) {
    return [];
  }

  return menuInfo.data.attributes.menu.map((menuItem) => ({
    id: menuItem.id,
    title: menuItem.label,
    image: menuItem.image?.data?.attributes?.url
      ? getImageFromStrapi(menuItem.image.data.attributes.url)
      : null,
    submenu:
      menuItem.submenu.length > 0
        ? menuItem.submenu.map((subMenuItem) => ({
            area: subMenuItem.label,
            items: subMenuItem.subitem.map((item) => ({
              title: item.label,
              slug: item.link,
              is_button: item.is_button,
            })),
            viewAll:
              subMenuItem.link && subMenuItem.link !== "#"
                ? {
                    title: translations?.view_all,
                    slug: subMenuItem.link,
                    is_button: subMenuItem.is_button,
                  }
                : null,
          }))
        : null, // Set submenu to null if no items are present
    slug: menuItem.link && menuItem.link !== "#" ? menuItem.link : null,
  }));
}

export default function Nav({
  menuInfo,
  setShowTopBar,
  regions,
  top_bar_items,
  languages,
  selectedLanguage,
  websiteType,
  websiteTitle,
  global_link,
  translations,
  other_languages
}) {
  const scrollTrigger = 10;
  const [chooseLocationOpen, setChooseLocationOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [openModal, setOpenModal] = useState(null);
  const [openModalSmall, setOpenModalSmall] = useState(false);

  const menuItems = transformMenuData(menuInfo,translations);

  const menuItemsSecondary = top_bar_items
    ? top_bar_items.map((item) => ({
        id: item.id,
        title: item.label,
        slug: item.link,
        internal: !item.new_tab,
      }))
    : [];

  return (
    <>
      <div className="sticky top-0 left-0 right-0 z-20">
        <TopBar
          other_languages={other_languages}
          menuItemsSecondary={menuItemsSecondary}
          languages={languages}
          translations={translations}
          selectedLanguage={selectedLanguage}
          websiteTitle={websiteTitle}
          setOpenModal={setOpenModal}
          setOpenModalSmall={setOpenModalSmall}
          websiteType={websiteType}
        />
        <MainNav
          menuItems={menuItems}
          menuItemsSecondary={menuItemsSecondary}
          searchOpen={searchOpen}
          setSearchOpen={setSearchOpen}
          openModal={openModal}
          setOpenModal={setOpenModal}
          openModalSmall={openModalSmall}
          setOpenModalSmall={setOpenModalSmall}
          scrollTrigger={scrollTrigger}
          websiteType={websiteType}
          tablet_image={
            menuInfo?.data?.attributes?.tablet_image?.data?.attributes?.url
          }
        />
        <MenuSearch
          isVisible={searchOpen}
          setSearchOpen={setSearchOpen}
          setOpenModal={setOpenModal}
          translations={translations}
        />
      </div>
    </>
  );
}
